<template>
  <div class="dashboard__view">
    <div class="page">
      <div class="relative">
        <div class="text-light">
          <p>
            Filter Audit Trails by : :
            <span @click="openFilters = !openFilters"
            >All Audit Trails
              <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  :class="openFilters ? '' : 'rotate'"
              >
                <path
                    d="M1 1L5 5L9 1"
                    stroke="#e00b5b"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
              </svg>
            </span>
          </p>
        </div>
        <div class="filter-dropdown" v-if="openFilters">
          <div class="filter-title">Transaction</div>
          <div class="form__item">
            <input
                class="form__input"
                type="text"
                v-model="filterList.type"
                placeholder="Type"
            />
          </div>
          <div></div>
          <div class="button-group">
            <button
                class="btn woven-border-only woven-red"
                @click="clearFilter"
            >
              Reset Filter
            </button>
            <button class="btn woven-color" @click="triggerFilter">
              <p>Filter</p>
            </button>
          </div>
        </div>
      </div>
      <br />
    </div>

    <div class="list">
      <div class="tab__content" style="padding: 20px 0">
        <div class="tab__content__top">
          <div class="tab__content__top__left">Your Audit Trail</div>
        </div>
        <EmptyState v-if="emptyState" type="not-found" icon="audit"  />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="loading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
            <tr>
              <th style="height: 50px; padding-bottom: 20px">USER</th>
              <th style="height: 50px; padding-bottom: 20px">TYPE</th>
              <th style="height: 50px; padding-bottom: 20px">COMMENTS</th>
              <th
                  style="height: 50px; padding-bottom: 20px; text-align: left"
              >
                DATE
              </th>
            </tr>
            </thead>
            <tbody>
            <tr :key="key" v-for="(item, key) in auditList">
              <td>{{ item.entity_actor }}</td>
              <td>{{ item.entity_type }}</td>
              <td>{{ item.entity_comment }}</td>
              <td style="text-align: left">{{ item.timestamp | date }}</td>
            </tr>
            </tbody>
          </table>
          <div
              class="table__details"
              v-if="!loading"
          >
            <div class="">
              <span class="text-muted"
              >Page {{ currentPage }} of
                {{ Math.ceil(totalAudits / defaultPageSize) }}</span
              >
            </div>
            <div class="table__details__right pagination-view">
              <Pagination :numberOfPages="totalAudits / defaultPageSize" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Pagination from "@/components/pagination.vue";
import emptyTransactions from "../../../components/emptytransactions";
import EmptyState from "@/components/empty-state.vue";

export default {
  metaInfo: {
    title: "Audit Trail",
  },
  data() {
    return {
      auditList: "",
      cursor: "",
      pageInfo: "",
      perPage: 10,
      disabled: false,
      filterList: {
        actor: this.$route.query.entity_actor
            ? this.$route.query.entity_actor
            : "",
        type: this.$route.query.entity_type
            ? this.$route.query.entity_type
            : "",
        datetime: this.$route.query.timestamp
            ? this.$route.query.timestamp
            : "",
      },
      loading: true,
      emptyState: false,
      loadMoreDisabled: false,
      openFilters: false,
      totalAudits: 0,
      currentPage: 1,
      defaultPageSize: 10
    };
  },

  created() {
    this.fetchaudits();
  },

  components: {
    Datepicker,
    emptyTransactions,
    Pagination, EmptyState
  },

  watch: {
    // call again the fetch method if the route changes; this is necessary especially because of users
    // using the search and might be on this route already.
    $route: "fetchaudits",
  },

  methods: {
    toggleShowDateFilter() {
      this.showFilterDateInput = !this.showFilterDateInput;
    },
    toggleFilters() {
      this.openFilters = !this.openFilters;
    },
    triggerFilter() {
      let queryObject = {};
      if (this.filterList.actor !== "") {
        queryObject.entity_actor = this.filterList.actor.trim();
      }
      if (this.filterList.type !== "") {
        queryObject.entity_type = this.filterList.type.trim();
      }
      if (this.filterList.datetime !== "") {
        queryObject.timestamp = moment(this.filterList.datetime).format(
            "YYYY-MM-DD"
        );
      }

      queryObject.page = 1;

      //Route to page with query
      this.$router.push({ path: "/dashboard/audittrail", query: queryObject });

      this.openFilters = false;
    },
    clearFilter() {
      this.filterList = {
        actor: "",
        type: "",
        datetime: "",
      };
      this.openFilters = false;
      this.$router.push({ path: "/dashboard/audittrail" });
    },
    fetchaudits() {
      let generatedQuery = this.returnQuery();
      // Convert object to multiple arrays with name and value
      this.currentPage = this.$route.query.page;
      this.$http
          .get(`dashboard/audits?${generatedQuery}`)
          .then((response) => {
            if (response.body.data.audits.length > 0) {
              this.auditList = response.body.data.audits;
              this.cursor = response.body.data.cursor;
              this.totalAudits = response.body.data.total
              this.loading = false;
            } else {
              this.loading = false;
              this.auditList = "";
              this.cursor = null;
            }
          })
          .catch((error) => {
            // LOG Error
          });
    },
    returnQuery() {
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      // Loop through arrays and generate the query string
      for (let [name, value] of queryParams) {
        generatedQuery += `${name}=${value}`;
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }
      return generatedQuery;
    },
    generatePaginationLink(pageNum) {
      return {
        path: "/dashboard/audittrail",
        query: {
          ...this.$route.query,
          page: pageNum,
        },
      };
    },
    loadMore() {
      this.loadMoreDisabled = true;
      this.$http
          .get(`dashboard/audits?cursor=${this.cursor}`)
          .then((response) => {
            if (response.body.data.audits.length > 0) {
              let newArray = this.auditList.concat(response.body.data.audits);
              this.auditList = newArray;
              this.cursor = response.body.data.cursor;
              this.loading = false;
              this.loadMoreDisabled = false;
            } else {
              this.loading = false;
              this.loadMoreDisabled = false;
            }
          })
          .catch((error) => {
            // LOG Error
          });
    },
  },
};
</script>

<style lang="scss" scoped>
// filter styles start
.relative {
  position: relative;
}

.rotate {
  transform: rotate(180deg);
}

.woven-color {
  background: #e00b5b;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 40px;

  svg {
    margin-right: 5px;
  }

  .btn--text {
    font-style: normal;
    font-weight: 500;
    color: #fff;
    width: 100%;
    text-align: center;
  }
}

.pagination-view {
  width: 65%;
  display: flex;
}

.woven-border-only {
  background: #fff;
  border: 1px solid #e00b5b;
  height: 40px;

  svg {
    margin-left: 5px;
  }

  .btn--text {
    font-style: normal;
    font-weight: 500;
    text-align: center;
    color: #e00b5b;
  }
}

.filter-dropdown {
  background: #fff;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 30px;
  z-index: 100;
  left: 145px;

  .form__item {
    margin-bottom: 16px;
  }
}

.woven-red {
  color: #e00b5b;
}

.button-group {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  margin-top: 32px;
  border-top: 1px solid rgba(196, 196, 196, 0.5);

  p {
    width: 100%;
  }

  .btn {
    width: 100px;
    height: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 10px;
    text-align: center;
  }
}

.date-group {
  display: flex;
}

.margin-right {
  margin-right: 16px;
}

.date {
  border: 0.5px solid rgba(97, 110, 124, 0.5);
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(97, 110, 124, 0.8);
  padding: 12px 10px;
  max-width: 112px;
}

.status-element {
  display: flex;

  svg {
    margin-right: 10px;
    cursor: pointer;
  }
}

.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;

  span {
    color: #e00b5b;
    cursor: pointer;
  }
}

.filter-title {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 14px;
  color: #9a9fa3;
  margin-bottom: 16px;
}

// filter styles end

.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    color: #e00b5b;
    cursor: pointer;
  }
}
.btn-filter {
  height: 50px;

  border: 1px solid #fd8387;
  box-sizing: border-box;
  border-radius: 4px;
  background: transparent !important;
}
</style>

<style lang="scss"  scoped>
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    color: #e00b5b;
    cursor: pointer;
  }
}
</style>